const defaultState = {
  loading: false,
  currencies: {},
  fetched: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'START_FETCHING_CURRENCY_RATE':
      return {
        ...state,
        loading: true,
      };
    case 'DONE_FETCHING_CURRENCY_RATE':
      return {
        ...state,
        loading: false,
        currencies: action.payload,
        fetched: true,
      };
    default:
      return state;
  }
};
